import { Component, OnInit, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
HC_exporting(Highcharts);
declare var $: any;
import * as moment from 'moment';
import { GroupService } from 'src/app/api/departure/group.service';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';

@Component({
  selector: 'app-group-guide-projection',
  templateUrl: './group-guide-projection.component.html',
  styleUrls: ['./group-guide-projection.component.css']
})
export class GroupGuideProjectionComponent implements OnInit {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  private thisComponent: GroupGuideProjectionComponent;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chart: Highcharts.Chart | undefined;
  updateFlag: boolean = false; // Flag para forzar la actualización

  date_range: any = null;
  tour: any = null;
  bookings: any = [];
  start_range: any = moment().subtract(6, 'days').startOf('day');
  end_range: any = moment().endOf('day');

  constructor(private groupService: GroupService) {
    this.thisComponent = this;
  }

  ngOnInit() {
    this.generateCalendar();
    this.generateGraph();
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range_projection')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        ranges: {
          'Últimos 7 días': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
          'Últimos 15 días': [moment().subtract(14, 'days').startOf('day'), moment().endOf('day')],
          'Últimos 30 días': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')]
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showCustomRangeLabel: false,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.resetGraph();
        component_.init();
      }
    );
  }

  resetGraph() {
    if (this.chart) {
      // Eliminar todas las series
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false); // Eliminar la primera serie hasta que no haya más
      }

      // Desactivar la leyenda
      this.chart.update({
        legend: {
          enabled: false // Desactivar la leyenda
        }
      });

      // Redibujar el gráfico
      this.chart.redraw();
    }
  }

  init() {
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD');

    this.groupService.guidesProjection(val_params).subscribe({
      next: (data: any) => {
        let guides = data.guides;
        let tours = data.tours;
        let results = data.results;
        let categories: any = [];
        let series: any = [];

        // console.log(results);

        // categories
        for (let i in tours) {          
          categories.push(tours[i].description);
        }

        //  series
        for (let i in guides) {
          let obj_: any = {
            name: guides[i].fullname
          };
          obj_.data = [];
          for (let j in results){
            if(results[j].guide_id == guides[i].id){
              obj_.data.push(results[j].total_grupos)
            }
          }
          series.push(obj_);
        }

        setTimeout(() => {
          this.updateChartData(categories, series);
        }, 200);
      }
    });
  }

  generateGraph(series_data: any = []) {
    this.chartOptions = {
      chart: {
        type: 'line',
        marginTop: 100
      },
      title: {
        text:
          'Histórico de salidas de guías turísticos',
        style: {
          fontSize: '1em'
        },
        align: 'left'
      },
      tooltip: {
        headerFormat:
          '<div class="text-center"><b>{point.key}</b></div><br/>', // Muestra el valor de xAxis
        pointFormat: '{series.name}: <b>{point.y:0f} salidas</b>',
        // pointFormat: 'N°: <b>{point.y:0f} pax</b>',
        style: {
          color: '#333333', // Color del texto
          fontSize: '12px',
          fontFamily: 'Arial' // Familia de fuente
        }
      },
      yAxis: {
        title: {
          text: 'N° de Salidas por Tour'
        }
      },
      xAxis: {
        categories: [],
        accessibility: {
            description: 'Months of the year'
        }
      },
      legend: {
        title: {
          text:
            'Lista de Guias',
        },
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemStyle: {
          fontSize: '11px'
        }
      },
      plotOptions: {
        series: {
          cursor: 'pointer',
          label: {
            connectorAllowed: false
          },
          // pointStart: Number(this.start_range.date())
        }
      },
      series: series_data,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }
        ]
      }
    };
  }

  updateChartData(categorias: any, series: any) {
    // Si la referencia del gráfico está disponible, actualiza las series
    if (this.chart) {
      this.chart.series.forEach((serie: Highcharts.Series) => {
        serie.remove(false); // Eliminar series antiguas sin redibujar
      });

      // Añadir cada serie con los datos nuevos
      series.forEach((serieData: any) => {        
        this.chart?.addSeries(
          {
            type: 'line', // Especificar el tipo de serie aquí
            name: serieData.name,
            data: serieData.data,
            // visible: serieData.day_number.length > 0 // Mostrar solo si hay datos en day_number
          } as Highcharts.SeriesOptionsType,
          false
        ); // No redibujar aún
      });

      this.chart.update({
        title: {
          text:
          'Histórico de salidas ('+this.getRangeLabel()+')',
          style: {
            fontSize: '1em'
          }
        },
        xAxis: {
          categories: categorias,
          title: {
            text:
              'Catálogo Tours/Excursiones',
              // 'Datos de los '+ this.getRangeLabel(),
          },
          offset: 10,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            label: {
              connectorAllowed: false
            },
          }
        },
        legend: {
          enabled: true // Desactivar la leyenda si no la deseas
        }
      });

      this.chart.redraw(); // Redibujar el gráfico con las nuevas series
      this.LoadingModalComponent.hide();
    }
  }

  // Recibir la referencia del gráfico cuando se crea
  onChartInstance(chartInstance: Highcharts.Chart) {
    this.chart = chartInstance;
  }

  getRangeLabel(): string {
    const daysDiff = this.end_range.diff(this.start_range, 'days') + 1;
  
    switch (daysDiff) {
      case 7:
        return 'Últimos 7 días';
      case 15:
        return 'Últimos 15 días';
      case 30:
        return 'Últimos 30 días';
      default:
        return (
          'Rango de fechas (' +
          this.start_range.format('YYYY-MM-DD') +
          ' - ' +
          this.end_range.format('YYYY-MM-DD') +
          ')'
        );
    }
  }


  close() {
    setTimeout(() => {
      this.start_range = moment();
      this.end_range = moment().endOf('month');
      this.generateCalendar();
      this.resetGraph();
    }, 250);
  }
}
